import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface HallmarkSlide1Props {
  isDark?: boolean;
}
export function HallmarkSlide1({
  isDark = false
}: HallmarkSlide1Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full flex items-center justify-center max-w-7xl mx-auto px-6 sm:px-12 py-16 sm:py-24" variants={containerVariants} initial="hidden" animate="visible" data-id="element-16">
      <div className="text-center max-w-4xl mx-auto" data-id="element-17">
        {/* Tagline */}
        <motion.div variants={itemVariants} className={`mb-8 sm:mb-10 inline-flex px-5 sm:px-7 py-2.5 rounded-full backdrop-blur-sm shadow-sm ${isDark ? 'bg-heliona-mint/10 border border-heliona-mint/30' : 'bg-heliona-mint/10 border border-heliona-mint/30'}`} data-id="element-18">
          <span className={`font-semibold text-xs sm:text-sm tracking-wider uppercase ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-19">
            Hallmark 90-Day Pilot Framework
          </span>
        </motion.div>

        {/* Main Title */}
        <motion.h1 variants={itemVariants} className={`text-4xl sm:text-6xl md:text-7xl font-serif font-medium mb-6 sm:mb-8 leading-[1.1] ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-20">
          Hallmark 90-Day Leadership Wellness Pilot
        </motion.h1>

        {/* Subtitle */}
        <motion.p variants={itemVariants} className={`text-lg sm:text-2xl mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-21">
          Designed to support the people behind the leadership
        </motion.p>

        {/* Supporting Line */}
        <motion.div variants={itemVariants} className={`text-base sm:text-lg font-medium ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-22">
          Insight. Support. Sustainable leadership at Day 90.
        </motion.div>
      </div>
    </motion.div>;
}